exports = module.exports = require("../../../../../../../shared/rnclient/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".invite-icon--image--1s76cQk9 {\n  vertical-align: middle;\n  width: 300px;\n  height: 240px;\n  text-align: center;\n  content: url(" + require("../../images/login-dialog.png") + ");\n}\n", "", {"version":3,"sources":["/./src/web/components/themes/invite-icon.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uCAA8C;CAC/C","file":"invite-icon.css","sourcesContent":[".image {\n  vertical-align: middle;\n  width: 300px;\n  height: 240px;\n  text-align: center;\n  content: url('../../images/login-dialog.png');\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"image": "invite-icon--image--1s76cQk9"
};


//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!/home/deploy/gamba/shared/rnclient/node_modules/postcss-loader/lib!./src/web/components/themes/invite-icon.css
// module id = 2790
// module chunks = 4